<template>
  <div class="mobile-container">
    <el-form :model="logisticsForm" class="mobile-form">
      <div class="form-group">
        <label class="form-label">{{$t('mobile.tempInStore.track')}}</label>
        <el-input
            autofocus
            type="textarea"
            @change="handleChangeText"
            :autosize="{ minRows: 3, maxRows: 6}"
            v-model="formInline.trackNumber"
            :placeholder="$t('mobile.tempInStore.track_err')"
            class="mobile-input"
        />
      </div>
      <div class="form-group">
        <label class="form-label">SKU / {{$t('mobile.tempInStore.quantity')}}</label>
        <div class="sku-list">
          <div v-for="(item, index) in formInline.skuList" :key="index" class="sku-item-card">
            <div class="sku-row">
              <div class="sku-select-wrapper">
                <el-select
                    v-model="item.SKU"
                    filterable
                    allow-create
                    :placeholder="$t('mobile.tempInStore.SKU')"
                    class="mobile-select"
                    :filter-method="filterSku"
                >
                  <el-option
                      v-for="option in materList"
                      :key="option"
                      :label="option"
                      :value="option"
                  />
                </el-select>
              </div>
              <div class="quantity-wrapper">
                <div class="quantity-control">
                  <button
                      type="button"
                      class="quantity-btn decrease"
                      @click="decreaseQuantity(index)"
                      :disabled="item.quantity <= 1"
                  >
                    <span>-</span>
                  </button>
                  <input
                      v-model.number="item.quantity"
                      type="number"
                      min="1"
                      max="99"
                      class="quantity-input"
                      @change="validateQuantity(index)"
                  />
                  <button
                      type="button"
                      class="quantity-btn increase"
                      @click="increaseQuantity(index)"
                  >
                    <span>+</span>
                  </button>
                </div>
              </div>
            </div>
            <button
                v-if="formInline.skuList.length > 1"
                type="button"
                class="remove-btn"
                @click="removeSku(index)"
            >
              <span>Delete this item</span>
            </button>
          </div>
          <button type="button" class="add-sku-btn" @click="addSku">
            <span class="add-icon">+</span>
            <span>Add SKU</span>
          </button>
        </div>
      </div>
      <div class="form-group">
        <label class="form-label">{{$t('mobile.tempInStore.selection')}}</label>
        <el-select
            v-model="formInline.warehouseId"
            filterable
            reserve-keyword
            :placeholder="$t('mobile.tempInStore.warehouse')"
            remote-show-suffix
            :loading="uploadLoading"
            class="mobile-select"
            @change="handleChange"
        >
          <el-option
              v-for="item in stockList"
              :key="item.warehousefCode"
              :label="item.warehouseName"
              :value="item.id"
          />
        </el-select>
      </div>
      <div class="form-group">
        <label class="form-label">{{$t("mobile.tempInStore.upload")}}</label>
        <div class="upload-desc">{{$t("mobile.tempInStore.upload_prompt")}}</div>
        <div class="upload-container">
          <el-upload
              ref="uploadRef"
              :on-success="getUploadUrl"
              :before-upload="handleBeforeUpload"
              v-model:file-list="formInline.imageOrign"
              :action="uploadUrl"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              class="mobile-upload"
          >
            <div class="upload-placeholder">
              <el-icon class="upload-icon"><Plus /></el-icon>
              <span class="upload-text">{{$t("mobile.tempInStore.upload")}}</span>
            </div>
          </el-upload>
          <!-- Loading overlay -->
          <!-- 在模板中添加进度条显示 -->
          <div v-if="uploadLoading" class="compression-progress">
            <div class="progress-text">{{ loadingText }}</div>
            <el-progress :percentage="compressionProgress" :show-text="false"></el-progress>
          </div>
        </div>
      </div>

      <div class="submit-section">
        <button type="button" class="submit-btn" @click="syncLogistics">
          {{$t('mobile.tempInStore.save')}}
        </button>
      </div>

    </el-form>
    <el-dialog
        v-model="dialogVisible"
        :title="$t('mobile.inStore.preview') "
        width="90%"
        class="preview-dialog"
        :close-on-click-modal="true"
    >
      <div class="preview-content">
        <img :src="dialogImageUrl" alt="Preview Image" class="preview-image" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {ElForm,ElSelect,ElOption,ElInput,ElMessage,ElUpload,ElIcon,ElDialog} from "element-plus";
import {tempInStore,tempInStoreMater} from "@/utils/api"
import {getFullUrl, getLocalStockList} from "../../../public/js";
import {uploadUrl} from "@/utils/requset";
import imageCompression from 'browser-image-compression';
export default {
  name: "tempInStore",
  components:{
    ElForm,ElSelect,ElOption,ElInput,ElUpload,ElIcon,ElDialog
  },
  data() {
    return {
      uploadUrl:"",
      dialogVisible:false,
      uploadLoading: false,
      loadingText: '',
      formInline: {
        skuList: [
          {
            SKU: "",
            quantity: 1
          }
        ],
        imageOrign:[],
        image:[],
        trackNumber:"",
        warehouseId:13
      },
      materList:[],
      materLists:[],
      stockList:[],
    };
  },
  beforeMount() {
    this.uploadUrl = uploadUrl
    this.formInline.trackNumber = this.$route.query.trackNumber+"\n";
    this.getLocalStockList()
    this.tempInStoreMater()
  },
  methods: {
    getLocalStockList(){
      getLocalStockList().then(res => {
        this.stockList = res.filter(item=>{
          return item.warehouseName.includes("美国售后仓")
        })
        let temp =  this.stockList.find(item=>{
          return item.warehouseName.includes("804-美国售后仓-不良品仓")
        })
        if(temp){
          this.formInline.warehouseId = temp.id
        }
      })
    },
    filterSku(mark){
      if(!mark){
        this.materList = []
      }else{
        this.materList =  this.materLists.filter(item=>{
          return item.toLowerCase().includes(mark.toLowerCase())
        })
      }
    },
    getUploadUrl(response){
      console.log(response)
      let url = getFullUrl(response.location)
      this.formInline.imageOrign[this.formInline.imageOrign.length-1].url = url
      this.formInline.image.push(url)
    },
    handleBeforeUpload(file){
      const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJPGOrPNG) {
        ElMessage.error(this.$t("mobile.returnList.uploadPrompt"));
        return false; // 不上传该文件
      } else if (file.size / 1024 / 1024 > 8) {
        ElMessage.error(this.$t("mobile.returnList.uploadSize"))
        return false
      }

      // 对 JPG 和 PNG 图片进行压缩
      if (isJPGOrPNG) {
        return new Promise((resolve) => {
          // 显示loading状态
          this.uploadLoading = true;
          this.loadingText = 'Compressing images...';
          this.compressionProgress = 0; // 重置进度
          
          // 模拟进度增加
          let progressInterval = setInterval(() => {
            if (this.compressionProgress < 80) { // 最大只到80%，剩下的20%留给上传
              this.compressionProgress += 5;
            }
          }, 200); // 每200毫秒增加5%进度
          
          // 用于存储当前最新的文件（原始文件或已压缩文件）
          let currentFile = file;

          // 添加超时控制，最多压缩15秒
          const timeout = 15000; // 15秒超时
          let timeoutId = setTimeout(() => {
            clearInterval(progressInterval); // 清除进度模拟
            ElMessage.warning(`图片压缩超时，当前文件大小 ${(currentFile.size / 1024).toFixed(1)}KB，将上传当前文件`);
            this.loadingText = 'Uploading images...';
            this.compressionProgress = 100; // 进度完成
            setTimeout(() => {
              this.uploadLoading = false;
              this.loadingText = '';
              this.compressionProgress = 0;
            }, 500);
            resolve(currentFile); // 超时时上传当前已压缩的文件
          }, timeout);

          // 首先检查文件大小，如果已经小于 300KB，则不压缩
          if (file.size <= 300 * 1024) {
            this.loadingText = 'Uploading images...';
            clearTimeout(timeoutId); // 清除超时定时器
            // 添加延迟确保loading状态能正确关闭
            setTimeout(() => {
              this.uploadLoading = false;
              this.loadingText = '';
              this.compressionProgress = 0;
            }, 500);
            resolve(file);
            return;
          }

          // 根据文件大小动态确定压缩参数
          let options;
          const fileSizeMB = file.size / 1024 / 1024;
          
          if (fileSizeMB > 2) {
            // 2MB以上的大文件，降低质量优先保证速度
            options = {
              maxSizeMB: 0.5, // 放宽到500KB
              maxWidthOrHeight: 1440, // 直接使用较小尺寸
              useWebWorker: true,
              initialQuality: 0.7, // 降低初始质量
            };
          } else if (fileSizeMB > 1) {
            // 1-2MB的文件，适度压缩
            options = {
              maxSizeMB: 0.4, // 400KB
              maxWidthOrHeight: 1600,
              useWebWorker: true,
              initialQuality: 0.8,
            };
          } else {
            // 小于1MB的文件，保持原有压缩质量
            options = {
              maxSizeMB: 0.3, // 最大 300KB
              maxWidthOrHeight: 1920,
              useWebWorker: true,
            };
          }

          imageCompression(file, options)
              .then(compressedFile => {
                // 更新当前文件为已压缩文件
                currentFile = compressedFile;
                
                // 检查压缩后的文件大小，如果仍然大于目标大小，则进一步压缩
                const targetSizeKB = options.maxSizeMB * 1024;
                if (compressedFile.size > targetSizeKB * 1024) {
                  this.loadingText = '正在进一步压缩图片...';
                  // 根据原文件大小确定二次压缩参数
                  let smallerOptions;
                  if (fileSizeMB > 5) {
                    smallerOptions = {
                      maxSizeMB: 0.5,
                      maxWidthOrHeight: 1080, // 更小的尺寸
                      useWebWorker: true,
                      initialQuality: 0.6,
                    };
                  } else {
                    smallerOptions = {
                      maxSizeMB: 0.3, // 最大 300KB
                      maxWidthOrHeight: 1440,
                      useWebWorker: true,
                    };
                  }
                  
                  return imageCompression(file, smallerOptions).then(smallerFile => {
                    clearInterval(progressInterval); // 清除进度模拟
                    this.compressionProgress = 90; // 设置为90%
                    ElMessage.success(`图片已压缩至 ${(smallerFile.size / 1024).toFixed(1)}KB`);
                    this.loadingText = 'Uploading images...';
                    this.compressionProgress = 100; // 进度完成
                    setTimeout(() => {
                      this.uploadLoading = false;
                      this.loadingText = '';
                      this.compressionProgress = 0;
                    }, 500);
                    resolve(smallerFile);
                  });
                }

                clearTimeout(timeoutId); // 清除超时定时器
                clearInterval(progressInterval); // 清除进度模拟
                ElMessage.success(`图片已压缩至 ${(compressedFile.size / 1024).toFixed(1)}KB`);
                this.loadingText = 'Uploading images...';
                this.compressionProgress = 90; // 设置为90%
                setTimeout(() => {
                  this.uploadLoading = false;
                  this.loadingText = '';
                  this.compressionProgress = 0;
                }, 500);
                resolve(compressedFile);
              })
              .catch(error => {
                clearTimeout(timeoutId); // 清除超时定时器
                clearInterval(progressInterval); // 清除进度模拟
                console.error('图片压缩失败:', error);
                ElMessage.warning('图片压缩失败，将上传原始图片');
                this.loadingText = 'Uploading images...';
                this.compressionProgress = 100; // 进度完成
                setTimeout(() => {
                  this.uploadLoading = false;
                  this.loadingText = '';
                  this.compressionProgress = 0;
                }, 500);
                resolve(file); // 如果压缩失败，仍然上传原始文件
              });
        });
      }
    },
    handleRemove(uploadFile, uploadFiles){
      console.log(uploadFile, uploadFiles)
      let fullUrl = getFullUrl(uploadFile.response.location)
      this.formInline.image = this.formInline.image.filter(item=>{
        return  item!=fullUrl
      })
    },
    tempInStoreMater(){
      tempInStoreMater().then(res=>{
        this.materList = res.Data
        this.materLists = res.Data
      }).catch(err=>{
        console.log(err)
      })
    },
    handlePictureCardPreview(uploadFile){
      this.dialogImageUrl = uploadFile.url
      this.dialogVisible = true
      return
    },
    handleChangeText(){
      const arr = this.formInline.trackNumber.split(/\r?\n/).filter(item => item.trim() !== '');

      // 使用Set去重并转回数组
      const uniqueArr = [...new Set(arr)]
      this.formInline.trackNumber = uniqueArr.join('\n')
    },
    addSku() {
      this.formInline.skuList.push({
        SKU: "",
        quantity: 1
      });
    },
    removeSku(index) {
      if (this.formInline.skuList.length > 1) {
        this.formInline.skuList.splice(index, 1);
      }
    },
    increaseQuantity(index) {
      this.formInline.skuList[index].quantity++;
    },
    decreaseQuantity(index) {
      if (this.formInline.skuList[index].quantity > 1) {
        this.formInline.skuList[index].quantity--;
      }
    },
    validateQuantity(index) {
      if (this.formInline.skuList[index].quantity < 1) {
        this.formInline.skuList[index].quantity = 1;
      }
    },
    syncLogistics() {
      // 验证SKU列表
      for (let i = 0; i < this.formInline.skuList.length; i++) {
        const item = this.formInline.skuList[i];
        if (!item.SKU) {
          ElMessage.error(`第${i + 1}行SKU不能为空`);
          return;
        }
        if (!item.quantity || item.quantity <= 0) {
          ElMessage.error(`第${i + 1}行数量必须大于0`);
          return;
        }
      }

      if (!this.formInline.warehouseId){
        ElMessage.error(this.$t('mobile.tempInStore.warehouse'))
        return
      }
      if (this.formInline.image.length <=0){
        ElMessage.error(this.$t('mobile.tempInStore.upload_prompt'))
        return
      }

      tempInStore(this.formInline).then(res=>{
        ElMessage.success(this.$t('saveSuccess') )
        // 等待1秒
        setTimeout(() => {
          this.$router.push('/mobile');
        }, 1000);
        console.log(res)
      }).catch(err=>{
        console.log(err)
      })
    }
  }
};
</script>

<style scoped>
/* 移动端容器样式 */
.mobile-container {
  min-height: 100vh;
  background: #fff;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* 上传容器样式 */
.upload-container {
  position: relative;
  display: inline-block;
  width: 100%;
}

/* 页面头部 */
.page-header {
  background: #fff;
  padding: 20px 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 0;
}

.page-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #2c3e50;
  text-align: center;
}

/* 表单容器 */
.mobile-form {
  padding: 16px;
  max-width: 100%;
  background: #fff;
}

/* 表单组样式 */
.form-group {
  background: transparent;
  padding: 20px 0;
  margin-bottom: 16px;
}

.form-label {
  display: block;
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 12px;
  line-height: 1.4;
}

/* 输入框样式 */
.mobile-input :deep(.el-textarea__inner) {
  border: 2px solid #e8f4fd;
  border-radius: 8px;
  padding: 12px;
  font-size: 16px;
  line-height: 1.5;
  background: #fafbfc;
  transition: all 0.3s ease;
  resize: vertical;
}

.mobile-input :deep(.el-textarea__inner:focus) {
  border-color: #409eff;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);
}

.mobile-select {
  width: 100% !important;
}

.mobile-select :deep(.el-input__wrapper) {
  border: 2px solid #e8f4fd;
  border-radius: 8px;
  padding: 8px 12px;
  background: #fafbfc;
  transition: all 0.3s ease;
  min-height: 44px;
}

.sku-select-wrapper .mobile-select :deep(.el-input__wrapper) {
  max-width: none;
}

.mobile-select :deep(.el-input__wrapper:hover) {
  border-color: #c6e2ff;
}

.mobile-select :deep(.el-input__wrapper.is-focus) {
  border-color: #409eff;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);
}

.mobile-select :deep(.el-input__inner) {
  font-size: 16px;
  color: #2c3e50;
}

/* SKU列表样式 */
.sku-list {
  width: 100%;
}

.sku-item-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.sku-item-card:hover {
  border-color: #cbd5e0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.sku-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.sku-select-wrapper {
  flex: 2;
  min-width: 0;
}

.quantity-wrapper {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.quantity-control {
  display: flex;
  align-items: center;
  background: #fff;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  width: fit-content;
  max-width: 100%;
}

.quantity-btn {
  width: 32px;
  height: 36px;
  border: none;
  background: #f7fafc;
  color: #4a5568;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.quantity-btn:hover:not(:disabled) {
  background: #edf2f7;
  color: #2d3748;
}

.quantity-btn:active:not(:disabled) {
  background: #e2e8f0;
  transform: scale(0.95);
}

.quantity-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.quantity-btn.decrease {
  border-right: 1px solid #e2e8f0;
}

.quantity-btn.increase {
  border-left: 1px solid #e2e8f0;
}

.quantity-input {
  width: 32px;
  height: 36px;
  border: none;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: #2d3748;
  background: #fff;
  outline: none;
}

.quantity-input::-webkit-outer-spin-button,
.quantity-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.quantity-input[type=number] {
  -moz-appearance: textfield;
}

.remove-btn {
  width: 100%;
  height: 40px;
  margin-top: 12px;
  background: #fed7d7;
  border: 2px solid #feb2b2;
  border-radius: 8px;
  color: #c53030;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.remove-btn:hover {
  background: #fbb6ce;
  border-color: #f687b3;
  color: #97266d;
}

.remove-btn:active {
  transform: scale(0.98);
}

.add-sku-btn {
  width: 100%;
  height: 50px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 12px;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.add-sku-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.add-sku-btn:active {
  transform: translateY(0);
}

.add-icon {
  font-size: 20px;
  font-weight: bold;
}

/* 上传区域样式 */
.upload-desc {
  font-size: 14px;
  color: #718096;
  margin-bottom: 12px;
  line-height: 1.5;
}

.mobile-upload :deep(.el-upload--picture-card) {
  width: 100px;
  height: 100px;
  border-radius: 12px;
  border: 2px dashed #cbd5e0;
  background: #f7fafc;
  transition: all 0.3s ease;
  margin: 4px;
}

.mobile-upload :deep(.el-upload--picture-card:hover) {
  border-color: #667eea;
  background: rgba(102, 126, 234, 0.05);
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(102, 126, 234, 0.2);
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #718096;
}

.upload-icon {
  font-size: 24px;
  margin-bottom: 4px;
  color: #a0aec0;
}

.upload-text {
  font-size: 12px;
  color: #a0aec0;
  text-align: center;
}

.mobile-upload :deep(.el-upload-list--picture-card .el-upload-list__item) {
  width: 100px;
  height: 100px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  margin: 4px;
}

.mobile-upload :deep(.el-upload-list--picture-card .el-upload-list__item:hover) {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.mobile-upload :deep(.el-upload-list--picture-card .el-upload-list__item-thumbnail) {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 提交按钮区域 */
.submit-section {
  padding: 20px 16px 40px;
  background: transparent;
}

.submit-btn {
  width: 100%;
  height: 56px;
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  border: none;
  border-radius: 16px;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 6px 20px rgba(79, 172, 254, 0.3);
  letter-spacing: 0.5px;
}

.submit-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(79, 172, 254, 0.4);
}

.submit-btn:active {
  transform: translateY(-1px);
}

/* 预览对话框 */
.preview-content {
  text-align: center;
  padding: 20px;
}

.preview-image {
  max-width: 100%;
  max-height: 70vh;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

/* 响应式设计 */
@media (min-width: 768px) {
  .mobile-container {
    max-width: 480px;
    margin: 0 auto;
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.1);
  }

  .sku-row {
    gap: 16px;
  }
}

@media (max-width: 480px) {
  .mobile-form {
    padding: 12px;
  }

  .form-group {
    padding: 2px 0;
    margin-bottom: 12px;
  }

  .page-header {
    padding: 16px 12px;
  }

  .submit-section {
    padding: 16px 12px 32px;
  }
}

/* 动画效果 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.form-group {
  animation: fadeInUp 0.5s ease-out;
}

.form-group:nth-child(1) { animation-delay: 0.1s; }
.form-group:nth-child(2) { animation-delay: 0.2s; }
.form-group:nth-child(3) { animation-delay: 0.3s; }
.form-group:nth-child(4) { animation-delay: 0.4s; }

/* 触摸友好的交互 */
@media (hover: none) and (pointer: coarse) {
  .quantity-btn:hover {
    background: #f7fafc;
  }

  .add-sku-btn:hover {
    transform: none;
  }

  .submit-btn:hover {
    transform: none;
  }
}

/* 自定义上传进度条样式 */
.compression-progress {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 20px;
  border-radius: 8px;
  z-index: 2000;
  min-width: 200px;
  text-align: center;
}

.progress-text {
  margin-bottom: 10px;
  font-size: 14px;
}

.mobile-upload :deep(.el-upload-list__item .el-progress) {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mobile-upload :deep(.el-upload-list__item .el-progress .el-progress-circle) {
  width: 40px !important;
  height: 40px !important;
}

.mobile-upload :deep(.el-upload-list__item .el-progress .el-progress__text) {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 10px !important;
  color: #409eff;
  z-index: 11;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

/* 确保进度条容器不会超出边界 */
.mobile-upload :deep(.el-upload-list__item .el-progress-circle) {
  overflow: visible;
}

/* Loading overlay styles */
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  border-radius: 12px;
}

.loading-content {
  text-align: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #409eff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-text {
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}
</style>



data() {
      return {
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
        },
        active: 0,
        formData: {
          containerNo: '',
          shippingLine: '',
          returnTime: '',
          remark: '',
          photos: [],
        },
        rules: {
          containerNo: [{ required: true, message: '请输入柜号', trigger: 'blur' }],
          shippingLine: [{ required: true, message: '请选择船公司', trigger: 'change' }],
          returnTime: [{ required: true, message: '请选择还柜时间', trigger: 'change' }],
        },
        shippingLineOptions: [],
        uploadHeaders: {},
        uploadData: {},
        actionUrl: '',
        dialogVisible: false,
        dialogImageUrl: '',
        uploadLoading: false,
        loadingText: '', // 添加一个变量来存储加载文本
        compressionProgress: 0, // 压缩进度
      };
    },